<template>
  <base-toggle
    v-bind="{ value, disabled }"
    v-model="modelValue"
    data-test-id="vf-toggle-token"
    @change="$emit('change', $event)"
  >
    <span
      class="forced-colors:b forced-colors:b-[ButtonBorder]"
      :class="[
        brandClasses.base,
        disabled ? brandClasses.disabled : selected
          ? [brandClasses.selected, 'forced-colors:o:bg-[ButtonBorder]']
          : [brandClasses.unselected, 'forced-colors:b forced-colors:b-[ButtonBorder]'],
        labelClass,
      ]"
    >
      <slot />
    </span>
  </base-toggle>
</template>

<script lang="ts" setup>
import type { CSSClass } from '#types/common'

const props = defineProps<{
  value?: string
  disabled?: boolean
  labelClass?: CSSClass
}>()

defineEmits<{ change: [value: boolean] }>()

const { brandClasses } = useAppConfig().components.vf.toggleToken

const modelValue = defineModel<boolean | string[]>()

const selected = computed(() =>
  isArray(modelValue.value) && props.value ? modelValue.value.includes(props.value) : modelValue.value
)
</script>
